import { Outlet } from "react-router-dom";

export default function Onboarding() {
  return (
    <div className="u-flex u-justify-center">
      <Outlet />
    </div>
  );
}
